module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "video"
  }, [_c('VideoCkplayer', {
    ref: "VideoCkplayer",
    attrs: {
      "videourl": _vm.vediosrc,
      "isLive": true,
      "isHtml5m3u8": true
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.listData), function(item) {
    return _c('li', {
      key: item.unid
    }, [_c('div', {
      staticClass: "videoname",
      class: {
        videonameactive: item.name == _vm.showactive
      },
      on: {
        "click": function($event) {
          _vm.videoitem(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("摄像头")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "video-infos"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" "), _c('label', [_vm._v("请选择以下信号源")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f0cf166","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/video/videolist.vue
// module id = 478
// module chunks = 1